import appointment from 'locales/plus/en/counter/appointment.json'
import doctorSchedule from 'locales/plus/en/counter/doctor-schedule.json'
import patientManagement from 'locales/plus/en/counter/patient-management.json'
import register from 'locales/plus/en/counter/register.json'
import recallLists from 'locales/plus/en/counter/recallLists.json'
import manageDoctorFee from 'locales/plus/en/counter/manage-doctor-fee.json'
import manageDoctorLabFee from 'locales/plus/en/counter/manage-doctor-lab-fee.json'

export const CounterEN = {
  ...appointment,
  ...doctorSchedule,
  ...patientManagement,
  ...register,
  ...recallLists,
  ...manageDoctorFee,
  ...manageDoctorLabFee
}
